export enum ASK_AI_BULK {
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=678831827
     */
    RUN = 'MICROAPP.RUN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=487259591
     */
    ANSWER = 'ASK_AI_RULES.ANSWER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=413011920
     */
    QUERY = 'LOOKER_PLATFORM_SEARCH_DASHBOARD_QUERY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=718807702
     */
    PLACEHOLDER = 'ASK_AI_BULK.PLACEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=718807567
     */
    BULK = 'ASK_AI_BULK.BULK',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=170044761
     */
    ADD_ROW_AFTER = 'WREX_TABLE.TABLE_TOOLBAR_ADD_ROW_AFTER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=686620152
     */
    STOP_STREAMING = 'ASK_AI_CONVERSATION.STOP_STREAMING',
}
